// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"1565b4f7","97":"8828020b","150":"5afb3d64","315":"d18061b4","438":"b3176b2d","455":"c1f47b9e","506":"8796c99b","522":"873038ae","591":"5f5adabd","860":"b180235c","878":"5cad601c","885":"9e60b6ad","935":"0b56ee7b","958":"106854ce","977":"3fa8f759"}[chunkId] + ".chunk.js";
};